import request from '@/utils/request'

let DriverApi = {


  userlist(data) {
        return request._post('/shop/plus.driver.Index/index', data);
    },

  /*删除司机*/
      deleteuser(data) {
        return request._post('/shop/user.user/delete', data);
  },


/*添加司机*/
add(data) {
    return request._post('/shop/plus.driver.Index/add', data);
},
/*修改司机*/
edit(data) {
    return request._post('/shop/plus.driver.Index/edit', data);
},
/*删除司机*/
del(data) {
    return request._post('/shop/plus.driver.Index/del', data);
},
/*司机详情*/
detail(data) {
  return request._post('/shop/plus.driver.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.driver.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.driver.Setting/getSetting', data, errorback);
    },
}
export default DriverApi;



// WEBPACK FOOTER //
// ./src/api/driver.js